import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import IconDepart from '@/components/icons/IconDepart.vue'
import IconDepartClock from '@/components/icons/IconDepartClock.vue'
import IconArrive from '@/components/icons/IconArrive.vue'
import IconArriveClock from '@/components/icons/IconArriveClock.vue'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#152649',
                secondary: '#999999',
                accent: '#777777',
                success: '#cdda32',
            },
            dark: {
                primary: '#152649',
                secondary: '#999999',
                accent: '#777777',
                success: '#cdda32',
            }
        },
        options: { customProperties: true },
    },
    icons: {
        values:{
            depart: {
                component: IconDepart
            },

            depart_clock: {
                component: IconDepartClock
            },

            arrive: {
                component: IconArrive
            },

            arrive_clock: {
                component: IconArriveClock
            },
        },
        iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
});
